import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
//----- store
import {
	fetchRequestsData,
	fetchEnrolledData,
	fetchCompletedData,
} from "../store/MyCourses-actions";

import FormEnrolledFilter from "../components/FormEnrolledFilter/FormEnrolledFilter";
import FormRequestsFilter from "../components/FormRequestsFilter/FormRequestsFilter";
import FormCompletedFilter from "../components/FormCompletedFilter/FormCompletedFilter";
import TableRequests from "../components/TableRequests/TableRequests";
import TableInscription from "../components/TableInscription/TableInscription";
import TableRealized from "../components/TableRealized/TableRealized";

import BoxTitle from "../components/BoxTitle/BoxTitle";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Box from "@material-ui/core/Box";

import Styles from "./MyCourses.module.css";

const MyCourses = () => {
	const dispatch = useDispatch();
	const [myCoursesDataLoaded, setMyCoursesData] = useState(false);
	const [activeTab, setActiveTab] = useState(1);
	const params = useParams();
	const history = useHistory();

	const MyCoursesData = useSelector((state) => state.MyCoursesData);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const url_data =
		apiConfigData.endpoint.domain + apiConfigData.endpoint.myCourses;

	const pedidosBtnHandler = () => {
		setActiveTab(0);
		history.push("/formacao/courses/requests");
	};

	const matriculadosBtnHandler = () => {
		setActiveTab(1);
		history.push("/formacao/courses/enrolled");
	};

	const realizadosBtnHandler = () => {
		setActiveTab(2);
		history.push("/formacao/courses/completed");
	};

	const filterData = (filterData) => {
		console.log(filterData);

		let filterString = "?";

		for (var key in filterData) {
			var value = filterData[key];
			if (value) {
				// console.log(key + ": " + value)
				filterString += "&" + key + "=" + value;
			}
		}

		console.log(filterString);

		// Filter?
		// name=Ac%C3%A7%C3%A3o%20INEFOP%20a%20decorrer%202 &
		// startDate=2021-07-27T00%3A00%3A00

		console.log("activeTab", activeTab);

		switch (activeTab) {
			case 0:
				dispatch(
					fetchRequestsData(
						apiConfigData.endpoint.domain +
							"/api/FrontOffice/EnrollmentRequest" +
							filterString, autenticationData
					)
				);
				break;
			case 1:
				dispatch(
					fetchEnrolledData(
						url_data + "/Enrolled/Filter" + filterString, autenticationData
					)
				);
				break;
			case 2:
				dispatch(
					fetchCompletedData(
						url_data + "/Completed/Filter" + filterString, autenticationData
					)
				);
				break;
		}
	};

	useEffect(() => {
		console.log("activeTab", activeTab);
		switch (activeTab) {
			case 0:
				dispatch(
					fetchRequestsData(
						apiConfigData.endpoint.domain +
							"/api/FrontOffice/EnrollmentRequest", autenticationData
					)
				);
				break;
			case 1:
				dispatch(fetchEnrolledData(url_data + "/Enrolled/Filter", autenticationData));
				break;
			case 2:
				dispatch(fetchCompletedData(url_data + "/Completed/Filter", autenticationData));
				break;
		}
	}, [dispatch, activeTab]);

	useEffect(() => {
		console.log("MyCoursesData updated");
		console.log("MyCoursesData", MyCoursesData);
		// if (MyCoursesData.enrolledData.length > 0) {
		// 	setMyCoursesData(true);
		// }
	}, [MyCoursesData]);

	// useEffect(() => {
	// 	console.log("tab changed")
	// 	switch(activeTab){
	// 		case 0:
	// 			// dispatch(fetchEnrolledData(url_data + "/Enrolled/Filter"));
	// 			break;
	// 		case 1:
	// 			dispatch(fetchEnrolledData(url_data + "/Enrolled/Filter"));
	// 			break;
	// 		case 2:
	// 			dispatch(fetchCompletedData(url_data + "/Completed/Filter"));
	// 			break;
	// 	}
	// }, [activeTab]);

	return (
		<div className={Styles["MyCourses"]} style={{ color: "#ededed" }}>
			{/* {myCoursesDataLoaded && ( */}
			<div>
				<div className={`container ${Styles["container"]}`}>
					<div className={"row"}>
						<div className={"col-xs-4 title"}>Meus Cursos</div>
						<div className={"col-xs-8"}>
							<ButtonGroup className={"btn-group-top"}>
								<Button
									className={`${
										activeTab === 0
											? "btn-group-selected"
											: ""
									}`}
									style={{ width: "200px" }}
									onClick={pedidosBtnHandler}
								>
									Pré-inscrições
								</Button>
								<Button
									// className={"btn-group-selected"}
									className={`${
										activeTab === 1
											? "btn-group-selected"
											: ""
									}`}
									style={{ width: "200px" }}
									onClick={matriculadosBtnHandler}
								>
									Matriculados
								</Button>
								<Button
									className={`${
										activeTab === 2
											? "btn-group-selected"
											: ""
									}`}
									style={{ width: "200px" }}
									onClick={realizadosBtnHandler}
								>
									Realizados
								</Button>
							</ButtonGroup>
						</div>
					</div>
				</div>

				{activeTab === 0 && (
					<div className={Styles["full-container"]}>
						<div className={`container ${Styles["container"]}`}>
							<div className={"row"}>
								<div className={"col-xs-12"}>
									<FormRequestsFilter
										filterData={filterData}
									/>
								</div>
							</div>
						</div>
					</div>
				)}

				{activeTab === 1 && (
					<div className={Styles["full-container"]}>
						<div className={`container ${Styles["container"]}`}>
							<div className={"row"}>
								<div className={"col-xs-12"}>
									<FormEnrolledFilter
										filterData={filterData}
									/>
								</div>
							</div>
						</div>
					</div>
				)}

				{activeTab === 2 && (
					<div className={Styles["full-container"]}>
						<div className={`container ${Styles["container"]}`}>
							<div className={"row"}>
								<div className={"col-xs-12"}>
									<FormCompletedFilter
										filterData={filterData}
									/>
								</div>
							</div>
						</div>
					</div>
				)}

				<div className={`container ${Styles["container"]}`}>
					<div className={"row"}>
						<div className={"col-xs-12"}>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									{activeTab === 0 && (
										<Box
											component="div"
											className={"box-container"}
										>
											<BoxTitle title={`Pré-inscrições (${MyCoursesData.requestsData.length})`} />
											<TableRequests
												TableRequestsData={
													MyCoursesData.requestsData
												}
											/>
										</Box>
									)}
									{activeTab === 1 && (
										<Box
											component="div"
											className={"box-container"}
										>
											<BoxTitle title={`Matriculados (${MyCoursesData.enrolledData.length})`} />
											<TableInscription
												TableInscriptionData={
													MyCoursesData.enrolledData
												}
											/>
										</Box>
									)}
									{activeTab === 2 && (
										<Box
											component="div"
											className={"box-container"}
										>
											<BoxTitle title={`Realizados (${MyCoursesData.completedData.length})`} />
											<TableRealized
												TableRealizedData={
													MyCoursesData.completedData
												}
											/>
										</Box>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* )} */}
		</div>
	);
};

export default MyCourses;
